import { Card, CardContent } from "@/components/ui/card";
import { Users, CheckCircle, XCircle, RefreshCw, Clock, TrendingUp } from "lucide-react";

interface Props {
  total: number;
  success: number;
  failure: number;
  refund: number;
  inProgress: number;
  conversionRate: number;
  decisionRate: number;
}

export function TrialStatsSummaryCards({ total, success, failure, refund, inProgress, conversionRate, decisionRate }: Props) {
  const pct = (n: number) => total > 0 ? ((n / total) * 100).toFixed(1) : "0";

  const cards = [
    { label: "ทั้งหมด", value: total, icon: Users, color: "text-primary" },
    { label: "สำเร็จ", value: `${success} (${pct(success)}%)`, icon: CheckCircle, color: "text-green-600" },
    { label: "ไม่สำเร็จ", value: `${failure} (${pct(failure)}%)`, icon: XCircle, color: "text-red-600" },
    { label: "ขอคืนเงิน", value: `${refund} (${pct(refund)}%)`, icon: RefreshCw, color: "text-purple-600" },
    { label: "ดำเนินการ", value: `${inProgress} (${pct(inProgress)}%)`, icon: Clock, color: "text-amber-600" },
    { label: "อัตราปิดการขาย", value: `${conversionRate.toFixed(1)}%`, icon: TrendingUp, color: "text-emerald-600", sub: `ตัดสินใจแล้ว ${decisionRate.toFixed(1)}%` },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      {cards.map((c) => (
        <Card key={c.label}>
          <CardContent className="p-4">
            <div className="flex items-center gap-2 mb-2">
              <c.icon className={`h-5 w-5 ${c.color}`} />
              <span className="text-sm text-muted-foreground">{c.label}</span>
            </div>
            <p className="text-2xl font-bold">{c.value}</p>
            {c.sub && <p className="text-xs text-muted-foreground mt-1">{c.sub}</p>}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
